import { AsyncPipe, CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FilterStateService } from '@services/filter-state.service';
import { map, Observable } from 'rxjs';

@Component({
    selector: 'app-clear-filters-button',
    templateUrl: './clear-filters-button.component.html',
    styleUrls: ['./clear-filters-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, AsyncPipe]
})
export class ClearFiltersButtonComponent {
    readonly disabledClearFiltersBtn$: Observable<boolean>;
    constructor(private readonly filterStateService: FilterStateService<any, any>) {
        this.disabledClearFiltersBtn$ = this.filterStateService.stateFilters$.pipe(
            map((filters) => {
                return !filters || !this.someFilterApplied(filters);
            })
        );
    }

    async onClearAllFilters(): Promise<void> {
        this.filterStateService.clearAllFilters();
    }

    private someFilterApplied(filters: Record<string, any>): boolean {
        return Object.values(filters).some((f) => (Array.isArray(f) ? f.length > 0 : !!f));
    }
}
